module.exports = __webpack_public_path__ + "static/media/recipe-icon.ad337b32.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/recipe-icon.png
// module id = 202
// module chunks = 0